'use client';

import { useTranslations } from 'next-intl';
import { UIStoreInfoCard } from '@headless-workspace/core-ui';
import { GlowClickable, GlowTextBody, GlowTextCaption } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { useStoreSelectionHelpers } from '../../../../../client';
import { StoreInfoValue } from '../../../../../server';

export type StoresListProps = {
    favoriteStoreId?: string;
    highlightedStoreId?: string;
    stores: StoreInfoValue[];
    setHighlightedStore: (storeId: StoreInfoValue) => void;
    onMoreStoresVisibleClick: (visible: boolean) => void;
    displayMoreStoresVisibleButton: boolean;
};

export const StoresList: Component<StoresListProps> = ({
    favoriteStoreId,
    setHighlightedStore,
    highlightedStoreId,
    stores,
    onMoreStoresVisibleClick,
    displayMoreStoresVisibleButton,
}) => {
    const t = useTranslations('Modal.stores');
    const { legalMentionsDTSModal, onOpenMenu, mapStoreInfoToUIStoreInfoCardStore } = useStoreSelectionHelpers();

    const getStoreProps = (store: StoreInfoValue) => ({
        ...mapStoreInfoToUIStoreInfoCardStore(store, favoriteStoreId),
        isSelected: highlightedStoreId === store.id,
    });

    const handleClickMoreStoresVisible = () => {
        onMoreStoresVisibleClick(true);
    };

    const onSelectedStore = (store: StoreInfoValue) => () => {
        setHighlightedStore(store);
    };

    return (
        <>
            <ul className={'flex flex-col gap-1'}>
                {stores.map((store) => (
                    <li key={store.id}>
                        <UIStoreInfoCard
                            favoriteLabel={t('card.label.favoriteStore')}
                            onSelect={onSelectedStore(store)}
                            store={getStoreProps(store)}
                            handleDTSInfoClick={() => onOpenMenu(legalMentionsDTSModal)}
                        />
                    </li>
                ))}
            </ul>
            {displayMoreStoresVisibleButton && (
                <GlowClickable
                    content={{
                        labelElement: <GlowTextBody text={t('list.action.seeMore')} textDecoration={'underline'} />,
                    }}
                    onClick={handleClickMoreStoresVisible}
                    className={'p-1 mx-auto'}
                />
            )}
            <GlowTextCaption text={t('list.label.stockDisclaimer')} color={'tertiary'} className={'mt-auto'} />
        </>
    );
};
